import { Injectable } from '@angular/core';
import { ApiCallContext } from '@safarilaw-webapp/shared/common-objects-models';
import { FileObjectAdapter, SafariRequired } from '@safarilaw-webapp/shared/crud';
import { SubmissionFileObject } from '../models/app/submission-file-object';

@Injectable({
  providedIn: 'root'
})
export class SubmissionFileObjectAdapter extends FileObjectAdapter {
  toCreateModel(model: SubmissionFileObject, context?: ApiCallContext<any>): SafariRequired<Map<string, string | number>> {
    const formValues = super.toCreateModel(model, context);

    formValues.set('IntakePortalId', this.helpers.toApiId(model.intakePortalId));
    formValues.set('field', this.helpers.toApiId(model.fieldId));

    return formValues;
  }
}
